import { normalizeLocale } from '@/config/locales'

const loaders = import.meta.glob(['./locales/*.ts', '!./locales/*.test.ts', '!./locales/*.spec.ts'])
const domainLoaders = import.meta.glob('../../locales/domain.*.json')
const messageLoaders = import.meta.glob('../../locales/messages.*.json')

export async function loadRuntimeCatalogues(languages: string[]): Promise<Record<string, Record<string, string>>> {
  return Object.fromEntries(await Promise.all(languages.map(async code => {
    const load = domainLoaders[`../../locales/domain.${code}.json`]
    if (!load) throw new Error(`Missing runtime catalogue: ${code}`)
    const common = messageLoaders[`../../locales/messages.${code}.json`]
    if (!common) throw new Error(`Missing common messages: ${code}`)
    const [module, shared] = await Promise.all([load(), common()]) as { default: Record<string, string> }[]
    return [code, { ...module.default, ...shared.default }] as const
  })))
}

export async function loadLocaleMessages(locale: string): Promise<Record<string, any> | undefined> {
  const code = normalizeLocale(locale)
  if (!code) return undefined
  const load = loaders[`./locales/${code}.ts`]
  if (!load) return undefined
  try {
    const module = await load() as { default?: Record<string, any> }
    return module.default
  } catch { return undefined }
}

export async function loadMessageParameters(): Promise<Record<string, Record<string, string>>> {
  return (await import('../../locales/domain-parameters.json')).default
}
